import React from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useFetch, useLanguage, usePagination } from "hooks";
import { Layout, GridList, BookCard, Skeletons, AuthorCard } from "components";

/**
 * type can be (1: Most searched subjects, 2: Most searched authors, 3: Most searched books)
 * type 2 design in deferent way because type 2 for authors
 * this page taking type_id from the url parameters and call "getHomeTabsData" endpoint with the type_id, discover=1 and page
 */

const Discover = () => {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { type_id } = useParams();
  const { page } = usePagination(); // react hook that handle pagination by setting and getting page number from url query
  const [itemsResponse, itemsRequest] = useFetch(
    `getHomeTabsData?type=${type_id}&discover=1&page=${page}`
  );

  React.useEffect(() => {
    itemsRequest();
  }, [itemsRequest, page]);

  const Tabs = [
    {
      title: language.mostSearchingBooks,
    },
    {
      title: language.mostSearchedAuthors,
    },
    {
      title: language.topRatedBooks,
    },
  ]; // array of types titles

  return (
    <Layout>
      <div id="books_page" className="page_container pt-5">
        <section className="mb-3">
          <Container>
            <Row>
              <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                <h1 className="fw-medium text-primary cut-text-2">
                  {Tabs[type_id - 1].title}
                </h1>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="mb-3">
          <Container>
            <Row>
              <Col xs={12} className="mx-auto">
                {!itemsResponse.loading && itemsResponse.result.data ? (
                  <GridList
                    perRow={4}
                    itemsCount={itemsResponse.result.meta.total} // for the pagination
                    perPage={itemsResponse.result.meta.per_page} // for the pagination
                    as={type_id == 2 ? AuthorCard : BookCard}
                    items={itemsResponse.result.data}
                  /> // component that show the Grid List of items components; row contains columns and taking as that a react component or function returns a react component
                ) : (
                  <Skeletons.CardsSkeleton count={12} perRow={3} /> // in data loading it gonna display
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
};

export default Discover;
